import React from 'react';
import { File, List, MessageSquare } from 'react-feather';

import { TYPE_ICONS } from 'constants/config';
import { Icon } from 'ui';

const TYPE_TO_ICON = {
  lesson: File,
  draft_lesson: File,
  resource: File,
  path: List,
  practice_container: MessageSquare,
};

export default function AdvancedSearchContentTypeIcon({
  contentType,
  isScorm,
  certificationId,
}) {
  if (contentType === 'lesson' && isScorm) {
    return (
      <Icon
        className="c-midnight-50 AdvancedSearchResultCard-icon-result"
        name={TYPE_ICONS.Scorm}
      />
    );
  }
  if (contentType === 'path' && certificationId) {
    return (
      <Icon
        className="c-midnight-50 AdvancedSearchResultCard-icon-result"
        name={TYPE_ICONS.Certification}
      />
    );
  }

  const Component = TYPE_TO_ICON[contentType];
  return (
    <Component
      className="c-midnight-50 mb-1 AdvancedSearchResultCard-icon-result"
      size={15}
    />
  );
}
